import React from 'react';
import Modal from 'react-modal';

// Make sure to bind modal to your appElement for accessibility
Modal.setAppElement('#root');

const ImagePopup = ({images, setIsOpen, photoIndex, setPhotoIndex}) => {
    const modalStyles = {
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        content: {
            position: 'relative',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            border: 'none',
            background: 'transparent',
            padding: 0,
            maxWidth: '90vw',
            maxHeight: '90vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
    };

    const handlePrevious = () => {
        setPhotoIndex((photoIndex + images.length - 1) % images.length);
    };

    const handleNext = () => {
        setPhotoIndex((photoIndex + 1) % images.length);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <Modal
            isOpen={true}
            onRequestClose={handleClose}
            style={modalStyles}
            contentLabel="Image Lightbox"
        >
            <div className="lightbox-container" style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {/* Close Button */}
                <button
                    className="lightbox-close"
                    onClick={handleClose}
                    style={{
                        position: 'absolute',
                        top: '-50px',
                        right: '0',
                        background: 'transparent',
                        border: 'none',
                        color: 'white',
                        fontSize: '30px',
                        cursor: 'pointer',
                        zIndex: 1001,
                        padding: '10px',
                        fontWeight: 'bold'
                    }}
                >
                    ×
                </button>

                {/* Previous Button */}
                {images.length > 1 && (
                    <button
                        className="lightbox-prev"
                        onClick={handlePrevious}
                        style={{
                            position: 'absolute',
                            left: '-60px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            background: 'rgba(255, 255, 255, 0.2)',
                            border: 'none',
                            color: 'white',
                            fontSize: '30px',
                            cursor: 'pointer',
                            padding: '15px 20px',
                            borderRadius: '4px',
                            zIndex: 1001
                        }}
                    >
                        ‹
                    </button>
                )}

                {/* Main Image */}
                <img
                    src={images[photoIndex]}
                    alt={`Gallery item ${photoIndex + 1}`}
                    style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                        borderRadius: '4px'
                    }}
                />

                {/* Next Button */}
                {images.length > 1 && (
                    <button
                        className="lightbox-next"
                        onClick={handleNext}
                        style={{
                            position: 'absolute',
                            right: '-60px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            background: 'rgba(255, 255, 255, 0.2)',
                            border: 'none',
                            color: 'white',
                            fontSize: '30px',
                            cursor: 'pointer',
                            padding: '15px 20px',
                            borderRadius: '4px',
                            zIndex: 1001
                        }}
                    >
                        ›
                    </button>
                )}

                {/* Image Counter */}
                {images.length > 1 && (
                    <div
                        className="lightbox-counter"
                        style={{
                            position: 'absolute',
                            bottom: '-50px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            color: 'white',
                            fontSize: '14px',
                            background: 'rgba(0, 0, 0, 0.5)',
                            padding: '8px 16px',
                            borderRadius: '20px'
                        }}
                    >
                        {photoIndex + 1} / {images.length}
                    </div>
                )}

                {/* Navigation Dots */}
                {images.length > 1 && images.length <= 10 && (
                    <div
                        className="lightbox-dots"
                        style={{
                            position: 'absolute',
                            bottom: '-90px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            display: 'flex',
                            gap: '8px'
                        }}
                    >
                        {images.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setPhotoIndex(index)}
                                style={{
                                    width: '12px',
                                    height: '12px',
                                    borderRadius: '50%',
                                    border: 'none',
                                    background: index === photoIndex ? 'white' : 'rgba(255, 255, 255, 0.5)',
                                    cursor: 'pointer'
                                }}
                            />
                        ))}
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default ImagePopup;
